export class Language {

    readonly id: string;
    readonly languageLong: string;
    readonly countryName: string;

    constructor(id: string, languageLong: string, countryName: string) {
        this.id = id;
        this.languageLong = languageLong;
        this.countryName = countryName;
    }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/language.ts